import { createLogger } from '@/utils/logger';

const consoleLogger = createLogger();

export default ({ app }, inject) => inject('logger', consoleLogger);
